import { unitId } from '@/annotations'
import { AuthCard } from '@/components/AuthCard'
import { AuthCardBrand } from '@/components/AuthCardBrand'
import { AuthCardLead } from '@/components/AuthCardLead'
import { Strip } from '@/components/Strip'
import { AUTH_BRAND, A_VERIFYEXP_COPY } from '@/copy/registry'

/**
 * `a-verifyexp` — the honest counterpart of `a-verify`. "An expired link is a state, not an
 * error" — the address stays `pending`, never silently removed (§20.2). `display` is
 * server-formatted, same rule as `AVerify`. No control on this screen — "Nothing on it calls
 * anything" (process/09-SCREEN-SPECS/a-verifyexp.md).
 */
export function AVerifyexp({ display }: { display?: string }) {
  return (
    <AuthCard unitId={unitId('a-verifyexp')}>
      <AuthCardBrand label={AUTH_BRAND} />
      <h3 className="m-0 mb-3 text-section font-semibold">{A_VERIFYEXP_COPY.heading}</h3>
      <AuthCardLead>{display ?? A_VERIFYEXP_COPY.fallbackLead}</AuthCardLead>
      <div className="my-14">
        <Strip>{A_VERIFYEXP_COPY.reinviteStrip}</Strip>
      </div>
    </AuthCard>
  )
}
